// Klaviyo back-in-stock signup (snippets/back-in-stock.liquid).
// Delegated so it keeps working after Dawn re-renders the block on variant change.
(function () {
  if (window.sambobBackInStock) return;
  window.sambobBackInStock = true;

  const REVISION = '2024-10-15';

  function showMessage(form, text, isError) {
    const message = form.querySelector('.back-in-stock__message');
    message.textContent = text;
    message.hidden = false;
    message.classList.toggle('back-in-stock__message--error', isError);
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-back-in-stock]');
    if (!form) return;
    event.preventDefault();

    const strings = window.sambobBackInStockStrings || {};
    const email = form.elements.email.value.trim();
    if (!form.elements.email.checkValidity() || !email) {
      showMessage(form, strings.invalid, true);
      form.elements.email.focus();
      return;
    }

    const button = form.querySelector('button[type="submit"]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    const body = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email } } },
        },
        relationships: {
          variant: {
            data: { type: 'catalog-variant', id: `$shopify:::$default:::${form.elements.variant_id.value}` },
          },
        },
      },
    };

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(form.dataset.companyId)}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: REVISION },
          body: JSON.stringify(body),
        }
      );
      if (!response.ok) throw new Error(`Klaviyo ${response.status}`);
      form.querySelector('.back-in-stock__row').hidden = true;
      showMessage(form, strings.success, false);
    } catch (error) {
      console.error('Back in stock signup failed', error);
      showMessage(form, strings.error, true);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
